import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-leaderboard-info-page',
  templateUrl: './leaderboard-info-page.component.html',
  styleUrls: ['./leaderboard-info-page.component.scss']
})
export class LeaderboardInfoPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
